import apiRequestCommon from './index'
import config from '@/v2/config'

export default {
  path: '/v1/carwash/prepaidCardsForAccountDelete',
  async get (authId) {
    await window.callNativeHTTPX()
    let headersParam = {
      'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
      'HTTP-X-DAPP-USERID': window.DAPP_USERID,
      'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
      'APP-USERS-AUTH-ID': authId
    }
    // ローカルは認証情報を参照しないように変更する
    if (process.env.VUE_APP_LOCAL === 'true') {
      headersParam = config.API_AUTH_HEADERS_PARAM
      headersParam['APP-USERS-AUTH-ID'] = config.API_HEADERS_PARAM.APP_USERS_AUTH_ID
    }

    return apiRequestCommon.get(`${this.path}`, {
      headers: headersParam
    })
  }
}
